import React from "react";
import { DateFilters } from "../../../../../components/ui/Form/Period";
import _Button from "../../../../../components/generic/_Button";
import { SelectAndSearch } from "../../../../../components/ui/Form/SelectAndSearch";
import DataWebservice from "./DataWebservice";
import { useReportWebservice } from "../hooks/useReportWebservice";
import { useFetchPartners } from "../hooks/useFetchPartners";
const Webservice = () => {
  const { formik, isLoading, _validate, handleReset, data } =
    useReportWebservice();
  const { data: partnerList } = useFetchPartners();

  return (
    <div className="flex flex-col">
      <div className="bg-white rounded-lg p-3">
        <div className="w-full flex justify-between gap-2">
          <DateFilters
            required
            setFilterFrom={(e) => formik.setFieldValue("period.dateFrom", e)}
            setFilterTo={(e) => formik.setFieldValue("period.dateTo", e)}
            errors={formik.errors}
            isClean={formik.values.period.dateFrom === ""}
          />
          <SelectAndSearch
            options={[
              {
                value: "",
                label: "Selecciona un partner",
                disabled: true,
              },
              ...partnerList.map((item) => {
                return {
                  value: item.uidpartner,
                  label: item.name,
                };
              }),
            ]}
            title="Partner"
            name="uid_partner"
            values={formik.values.uid_partner}
            handleChange={(e) => formik.setFieldValue("uid_partner", e)}
            onBlur={formik.handleBlur}
            errors={
              formik.errors && formik.touched ? formik.errors.id_customer : ""
            }
            isError={formik.errors && formik.errors.id_customer}
            placeholder="Busca un partner"
            required
          />
        </div>
        <div className="gap-2 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2">
          <_Button
            icon="clear_all"
            onClick={handleReset}
            disabled={isLoading}
            loading={isLoading}
            style="none"
            title="Limpiar"
            className="w-full"
          />
          <_Button
            icon="analytics"
            style="primary"
            onClick={async () => await _validate()}
            title="Generar Reporte"
            className="w-full"
          />
        </div>
      </div>
      <DataWebservice data={data} isLoading={isLoading} />
    </div>
  );
};

export default Webservice;
